(function ($) {
    "use strict";

    $(function () {
        $(".js-language-selector li.active a").on("click", function (e) {
            e.preventDefault();
        });

        $(".js-language-selector").hoverIntent({
            over: animateLanguageSelectorIn,
            out: animateLanguageSelectorOut,
            timeout: 300,
        });

        function animateLanguageSelectorIn(e) {
            $(".js-language-selector li:not(.active)").fadeIn(300);
            $(this).addClass("open");
        }

        function animateLanguageSelectorOut(e) {
            $(".js-language-selector li:not(.active)").fadeOut(300);
            $(this).removeClass("open");
        }

        $(".js-dropdown-trigger")
            .children()
            .first()
            .click(function (e) {
                if ($(this).attr("href") == "#") {
                    e.preventDefault();
                }
            });

        /* Controlling Dropdowns */
        $(".js-dropdown-trigger").hoverIntent({
            over: animateDropdownIn,
            out: animateDropdownOut,
            timeout: 300,
        });

        function animateDropdownIn(e) {
            $(this).find(".dropdown-menu").fadeIn(300);
            $(this).addClass("open");
        }

        function animateDropdownOut(e) {
            $(this).find(".dropdown-menu").fadeOut(300);
            $(this).removeClass("open");
        }
    });
})(jQuery);
